export default __webpack_public_path__ + "static/media/1964-3.40215e2f.png";